import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import notify from 'devextreme/ui/notify';
import ValidationEngine from 'devextreme/ui/validation_engine';
import { NOT_FOUND } from 'http-status-codes';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FusionAuthService } from '../../../shared/services/fusion-auth';
import { ContactService } from '../../../shared/services/ocl';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent implements OnInit, OnDestroy {
    public contactForm: UntypedFormGroup;
    public isLoading = false;
    public phonePattern: any = /^\d*$/;
    private onDestroy$: Subject<void> = new Subject<void>();

    constructor(private fb: UntypedFormBuilder, private authService: FusionAuthService, private contactService: ContactService) {
        this.contactForm = this.fb.group({
            firstName: new UntypedFormControl('', [Validators.required]),
            lastName: new UntypedFormControl('', [Validators.required]),
            email: new UntypedFormControl('', [Validators.required]),
            phone: new UntypedFormControl(''),
            message: new UntypedFormControl('', [Validators.required]),
        });
    }

    public ngOnInit() {
        const user = this.authService.Profile;
        this.contactForm.get('firstName')?.setValue(user.firstName);
        this.contactForm.get('lastName')?.setValue(user.lastName);
        this.contactForm.get('email')?.setValue(user.email);
    }

    public onInitialized(e: any) {
        setTimeout(() => {
            if (e && e.component) {
                e.component.focus();
            }
        });
    }

    public submit() {
        this.isLoading = true;
        const name = this.contactForm.get('firstName')?.value + ' ' + this.contactForm.get('lastName')?.value;
        const email = this.contactForm.get('email')?.value;
        const phone = this.contactForm.get('phone')?.value;
        const message = this.contactForm.get('message')?.value;
        this.contactService.sendEmail(name, email, phone, message).pipe(takeUntil(this.onDestroy$)).subscribe(response => {
            this.isLoading = false;
            if (response === false) {
                notify('There was a problem sending the mail', 'error');
            } else {
                notify('The email was sent successfully', 'success');
                ValidationEngine.resetGroup('contactForm');
            }
        }, (error) => {
            if (error.status === NOT_FOUND) {
                notify('There was a problem with Google Drive Setting', 'error', 3000);
            } else {
                notify('We are having trouble communicating with our servers!', 'error', 3000);
            }
        });
    }

    public ngOnDestroy(): void {
        this.onDestroy$.next(); this.onDestroy$.complete()
    }
}
